const MARKER_DEFAULT_FILL_COLOR = '#FFFFFF'
const MARKER_DEFAULT_STROKE_COLOR = '#000000'
const MARKER_GUIDELINE_STROKE_COLOR = '#FFFFFF'
const MARKER_DEFAULT_SELECTED_STROKE_COLOR = '#F39D22'
const MARKER_DEFAULT_STROKE_WIDTH = 2.5
const MARKER_HANDLE_DEFAULT_STROKE_WIDTH = 1.25
const MARKER_HANDLE_DEFAULT_SIZE = 7.5
const MARKER_DASH_LENGTH_DEFAULT = 15
const MARKER_DASH_SPACE_LENGTH_DEFAULT = 5
const MARKER_STICKY_RADIUS = 5
const CURSOR_SVG_STRING = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 92 92"><path d="M 63.269 55.583 l 25.589 -10.294 c 1.682 -0.677 1.459 -3.168 -0.362 -4.041 L 2.884 0.205 c -1.71 -0.82 -3.499 0.969 -2.679 2.679 l 41.043 85.612 c 0.873 1.821 3.364 2.044 4.041 0.362 l 10.294 -25.589 C 56.991 59.767 59.767 56.991 63.269 55.583 z" fill="black" stroke="white" stroke-width="4" stroke-linecap="round"/></svg>`

export {
  MARKER_DEFAULT_FILL_COLOR,
  MARKER_DEFAULT_STROKE_COLOR,
  MARKER_GUIDELINE_STROKE_COLOR,
  MARKER_DEFAULT_SELECTED_STROKE_COLOR,
  MARKER_DEFAULT_STROKE_WIDTH,
  MARKER_HANDLE_DEFAULT_STROKE_WIDTH,
  MARKER_HANDLE_DEFAULT_SIZE,
  MARKER_DASH_LENGTH_DEFAULT,
  MARKER_DASH_SPACE_LENGTH_DEFAULT,
  MARKER_STICKY_RADIUS,
  CURSOR_SVG_STRING,
}
